import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Screenshots from '../components/Screenshots';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import Mission from '../components/Mission';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';  // Changed from Newsletter
import Footer from '../components/Footer';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToTarget = location.state?.scrollTo;
    if (scrollToTarget) {
      setTimeout(() => {
        const element = document.getElementById(scrollToTarget);
        if (element) {
          const offsetTop = element.offsetTop - 120;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <Screenshots />
      <Features />
      <HowItWorks />
      <Testimonials />
      <Mission />
      <FAQ />
      <CTASection />  {/* Changed from Newsletter */}
      <Footer />
    </>
  );
};

export default HomePage;